module.exports = __webpack_public_path__ + "static/img/loading.1f3b1d8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 5